module.exports = __webpack_public_path__ + "img/img_left_nav_detail_hover.f90688d8.svg";